/**
 * The TabBase link in the header and the one-time TabBase pop-up.
 *
 * The pop-up shows at most once per browser. `claimTabBasePromo()` is the only way to
 * show it: it writes the "seen" mark *before* the pop-up appears and only says yes once
 * the mark has been read back. So closing the tab, reloading, or never clicking a button
 * still counts as seen, and a browser that can't store anything (private mode that throws,
 * storage blocked) never sees it at all rather than seeing it on every visit.
 *
 * localStorage is per browser and per device: a phone and a laptop each see it once, and
 * someone who clears their site data will see it again. Nothing short of an account can
 * do better, and ScaleBase has none.
 */

export const TABBASE_URL = 'https://tabs.scalebase.app';

export const TABBASE_PROMO_KEY = 'scalebase-tabbase-promo-seen';

/** How long someone is on the page before the pop-up appears. */
export const TABBASE_PROMO_DELAY_MS = 12000;

/** True if the pop-up has already been shown in this browser (or storage is unreadable). */
export function hasSeenTabBasePromo() {
  try {
    return localStorage.getItem(TABBASE_PROMO_KEY) !== null;
  } catch {
    return true;
  }
}

/**
 * Marks the pop-up as seen and returns true if the caller may show it now. Returns false
 * if it was already seen or the mark can't be stored.
 */
export function claimTabBasePromo() {
  try {
    if (localStorage.getItem(TABBASE_PROMO_KEY) !== null) return false;
    localStorage.setItem(TABBASE_PROMO_KEY, new Date().toISOString());
    return localStorage.getItem(TABBASE_PROMO_KEY) !== null;
  } catch {
    return false;
  }
}
